import { ScmAuthApi } from '@backstage/integration-react';
import { parseGitHubUrl } from './gitHubUrlParser';

export function isAllowedGitHubUrl(urlStr: string) {
  try {
    const url = new URL(urlStr);
    const hostname = url.hostname.toLowerCase();
    if (hostname === 'github.com' || hostname === 'raw.githubusercontent.com') {
      const pathParts = url.pathname.split('/').filter(Boolean);
      const owner = pathParts[0];
      const isAllowedOwner = ['equinor', 'equinor-playground'].includes(owner?.toLowerCase() ?? '');
      return isAllowedOwner;
    }
  } catch (error) {
    // Ignore invalid URLs - handled elsewhere
  }
  return false;
}

export function getGitHubApiUrl(url: string) {
  const parts = parseGitHubUrl(url);
  if (!parts) {
    throw new Error('Invalid GitHub URL format. Expected standard blob or raw URL.');
  }
  const { owner, repo, ref, path } = parts;
  return [`https://api.github.com/repos/${owner}/${repo}/contents/${path}?ref=${ref}`, path];
}

export async function getGitHubHeaders(scmAuthApi: ScmAuthApi, url: string) {
  const { token: userToken } = await scmAuthApi.getCredentials({ url });
  if (!userToken) {
    throw new Error('No authentication token available for this GitHub URL.');
  }
  return {
    Authorization: `Bearer ${userToken}`,
    Accept: 'application/vnd.github.v3.raw',
  };
}
